import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';
import { SecretItem } from './secret.interface';
import { Clipboard } from '@angular/cdk/clipboard';
@Component({
  selector: 'app-secret',
  templateUrl: './secret.component.html',
  styleUrls: ['./secret.component.scss']
})
export class SecretComponent {
  constructor(private http: HttpClient,
    private alert: AlertService,
    private clipboard: Clipboard,
  ) {
    this.getSecret();
  }

  Client_id: string = ""
  Client_secret: string = ""
  SecretItems!: SecretItem
  getSecret() {
    this.http.get(`secret`).subscribe({
      next: (res: any) => {
        this.SecretItems = res.data
      }
    })
  }

  createSecret() {
    this.http.post(`secret`, null).subscribe({
      next: (res: any) => {
        this.alert.notify(res.message, 'success')
      },
      error: (err: any) => {
        this.alert.notify(err.error.message, 'warning')
      },
      complete: () => {
        this.getSecret()
      }
    })
  }

  changeSecret(key: SecretItem) {
    this.alert.confirm('ถ้าคุณเปลี่ยน Key จะมีผลต่อระบบที่กำลังใช้ Key นี้อยู่จะไม่สามารถใช้งาน API ได้จนกว่าจะนำ Key ใหม่ไปเปลี่ยน คุณต้องการเปลี่ยน Key หรือไม่').then(fm => {
      if (fm.isConfirmed) this.http.put(`secret`, key).subscribe({
        next: (res: any) => {
          this.alert.notify(res.message, 'success')
        },
        error: (err: any) => {
          this.alert.notify(err.error.message, 'warning')
        },
        complete: () => {
          this.getSecret()
        }
      })
    })

  }


  copyText(item: string) {
    this.clipboard.copy(item);
    this.alert.notify('Copy Text Successfull', 'success')
  }
}

